import { render, staticRenderFns } from "./LangFlag.vue?vue&type=template&id=3a18aacd&"
import script from "./LangFlag.vue?vue&type=script&lang=js&"
export * from "./LangFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports